import RestClient from "@/api/utils/baseRestClient";
import { atmoClient } from "@/setup/clients/atmoClient";
import { toReportFormPayload } from "@/composables/reportSteppers/reportFormPayload";

class Generationformclient extends RestClient {
  toSnake(data) {
    if (data?.form) data = { ...data, form: toReportFormPayload(data.form) };
    return super.toSnake(data);
  }

  async duplicate(reportUuid) {
    const url = this.buildUrl(`${reportUuid}/duplicate`);
    const response = await this.client.post(url);
    return this.toCamel(response.data);
  }

  async archive(uuid, reportUuid) {
    const url = this.buildUrl(uuid, { omit_form: true });
    await this.client.patch(url, {
      report_uuid: reportUuid,
      is_archived: true,
    });
  }

  async updateWithoutFormEcho(form, uuid) {
    const url = this.buildUrl(uuid, { omit_form: true });
    const response = await this.client.put(url, this.toSnake({ ...form }));
    return { ...form, ...this.toCamel(response.data) };
  }
}

export const generationformclient = new Generationformclient(
  atmoClient,
  "generationforms"
);
